module.exports = __webpack_public_path__ + "img/621a7ea.jpg";